import { useGetPermissions } from "layouts/customHook";
import React from 'react';
import { PermisionDenied } from "views/pages/manage/common/commonComponents";
import WeekWiseCalculation from "./WeekWiseCalculation";
const WeekWiseCalculationWrapper=()=>{
 const userPermissions = useGetPermissions("withdrawlMaster");
    return (
        userPermissions
            ? <WeekWiseCalculation userPermissions={userPermissions} />
            : <PermisionDenied />
    );
}
export default WeekWiseCalculationWrapper;